import * as DesignPro from '@/components/mambas';
import lodash from 'lodash';
import Vue from 'vue';
import './antd';
import { valueTypeMap } from './extendsFields';
import { frameworks } from './frameworks';
const EnumValueType = DesignPro.setValueTypeMap(valueTypeMap);
const EnumGridFramework = DesignPro.setGridFramework(frameworks);
DesignPro.Locales.init({
    pagesContext: require.context('@/pages', true, /locales.ts$/),
});
lodash.set(Vue, 'valueType', EnumValueType);
lodash.set(Vue, 'gridFramework', EnumGridFramework);
Vue.use(DesignPro.install);
